const baseUrl = 'https://st-sub.jd.id/micro-app'
const baseUatUrl = 'http://test.jd.com'
const baseDevUrl = 'http://test.jd.com'
module.exports = {
  tms: {
    development: baseDevUrl + ':8081/',
    pre: baseUatUrl + ':8081/',
    prepare: 'https://st-site-yf.jd.com',
    yf: 'http://itms-staging.jd.com',
    yf2: 'http://itms-staging2.jd.com',
    yf4: 'http://itms-staging4.jd.com',
    production: '//st-itms.jd.com', // '//st-itms.jd.com', // 'https://ldms-ext-yf.jd.com', // 'http://st-itms.jd.com',
    holl: '//st-itms-eu.jd.com',
    hollgray: '//st-itms-eu-gray.jd.com',
    hollpre: '//st-itms-eu-yf.jd.com',
    gray: 'https://st-itms-gray.jd.com',
    siteEu: '//st-itms.jd.com',
    siteEuGray: '//st-itms-gray.jd.com',
    yftest: '//st-itms-test.jd.com'
  },
  server3pl: {
    development: baseDevUrl + ':8082/',
    pre: baseUatUrl + ':8082/',
    prepare: 'https://st-3pl1.jd.com',
    yf: 'http://3pl-staging.jd.com',
    yf2: 'http://3pl-staging2.jd.com',
    yf4: 'http://3pl-staging.jd.com',
    production: '//st-3pl.jd.com', // '//st-3pl.jd.com', // 'http://st-3pl.jd.com',
    holl: '//st-3pl-eu.jd.com',
    hollgray: '//st-3pl-eu.jd.com',
    hollpre: '//st-3pl-eu-yf.jd.com',
    gray: '//jx-yf.jd.com',
    siteEu: '//st-3pl-eu.jd.com',
    siteEuGray: 'https://st-3pl-eu-one-gray.jd.com',
    yftest: '//st-3pl-test.jd.com'
  },
  site: {
    development: baseDevUrl + ':8083/',
    pre: baseUatUrl + ':8083/',
    prepare: 'https://st-site-yf2.jd.com',
    yf: 'http://itms-staging.jd.com',
    yf2: 'http://itms-staging2.jd.com',
    yf4: 'http://itms-staging4.jd.com',
    production: 'https://st-site.jd.com', // 'https://ldms-ext-yf.jd.com', // 'http://st-itms.jd.com',
    holl: '//st-site-eu.jd.com',
    hollgray: '//st-site-eu-gray.jd.com',
    hollpre: '//st-site-yf-eu.jd.com',
    gray: 'https://st-site-gray.jd.com',
    siteEu: '//st-site.jd.com',
    siteEuGray: '//st-site-gray.jd.com',
    yftest: '//st-site-test.jd.com'
  },
  dms: {
    development: baseDevUrl + ':8084/',
    pre: baseDevUrl + ':8084/',
    uat: baseUatUrl + 'https://st-idms-yf.jd.com',
    prepare: 'https://st-idms-yf.jd.com',
    production: 'https://st-idms.jd.com',
    gray: 'https://st-idms-gray.jd.com',
    holl: '//st-idms-eu.jd.com',
    hollgray: '//st-idms-eu-gray.jd.com',
    hollpre: 'https://st-idms-yf-eu.jd.com',
    siteEu: '//st-idms.jd.com',
    siteEuGray: '//st-idms-gray.jd.com',
    yftest: '//st-idms-test.jd.com'
  }
}
